import { render, staticRenderFns } from "./ResultDetailsPanel.vue?vue&type=template&id=5f62dc5b&scoped=true&"
import script from "./ResultDetailsPanel.vue?vue&type=script&lang=js&"
export * from "./ResultDetailsPanel.vue?vue&type=script&lang=js&"
import style0 from "./ResultDetailsPanel.vue?vue&type=style&index=0&id=5f62dc5b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f62dc5b",
  null
  
)

export default component.exports